import palette from '@lib/core/src/theme/palette';
import { Box, Stack, Typography } from '@mui/material';

import { ArrowFlowProcess } from './AgentConfigStyles';
import { AgentProcessCard } from './AgentProcessCard';
import { AgentConfigType } from './AgentsListConfig';

export const AgentProcess = ({ process }: { process: AgentConfigType['agentProcess'] }) => (
  <Stack
    sx={{
      borderLeft: `1px solid ${palette.grey[1200]}`,
      background: `linear-gradient(180deg, rgba(230, 227, 255, 0.05) 0%, rgba(237, 163, 254, 0.05) 32%, rgba(61, 85, 255, 0.05) 72.5%, rgba(86, 114, 230, 0.05) 100%), ${palette.white}`,
      padding: {
        md: '0 8px 0px 8px',
        lg: '0 24px 0px 20px'
      },
      borderTopRightRadius: '16px',
      flex: 1,
      overflowY: 'auto'
    }}
  >
    <Typography sx={{ marginLeft: '20px', color: palette.black }}>Process</Typography>
    <Box sx={{ my: { md: 1, lg: 9 } }}>
      {process.map(({ title, description, startIcon, endIcon }, index) => (
        <Box key={`${title}-${index}`}>
          <AgentProcessCard
            key={title}
            title={title}
            description={description}
            startIcon={startIcon}
            endIcon={endIcon}
          />
          {index !== process.length - 1 && <ArrowFlowProcess />}
        </Box>
      ))}
    </Box>
  </Stack>
);
